import { Component } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	templateUrl: './mtma-generic-entry-info.dialog.component.html',
	styles: `
	`
})

export class MtmaGenericEntryInfoDialogComponent {
	constructor(
		private refDialog: DynamicDialogRef
	) {}

	closeDialog(): void {
		this.refDialog.close();
	}

}